import * as React from 'react'
import {Navigate, Route, useLocation} from 'react-router-dom'

import {GetStartedScreen} from './screens/get-started/get-started'

const OnboardTeamWizardRoute = React.lazy(
    async () => import('./screens/pleo-guide/onboard-team-wizard-v2/onboard-team-wizard'),
)
const PleoGuidePage = React.lazy(async () => import('./screens/pleo-guide/pleo-guide-page'))
const PleoGuideSettingsPage = React.lazy(
    async () => import('./screens/pleo-guide/settings-wizard/settings-wizard'),
)
const StartSpendingPage = React.lazy(
    async () => import('./screens/pleo-guide/start-spending/start-spending'),
)
const TopupWalletPage = React.lazy(
    async () => import('./screens/pleo-guide/topup-wallet/topup-wallet/topup-wallet'),
)

export const routes = (
    <Route handle={{auth: true, allowedRoles: ['owner']}}>
        <Route index element={<LandingRedirect />} />
        <Route path="pleo-guide">
            <Route index element={<PleoGuidePage />} />
            <Route handle={{minCompanyStatus: 'fdd'}}>
                <Route path="topup-wallet" element={<TopupWalletPage />} />
                <Route path="start-spending" element={<StartSpendingPage />} />
            </Route>
            <Route path="setup-accounting" element={<PleoGuideSettingsPage />} />
            <Route path="onboard-team" element={<OnboardTeamWizardRoute />} />
        </Route>
        <Route path="get-started" element={<GetStartedScreen />} />
    </Route>
)

function LandingRedirect() {
    const location = useLocation()
    const isPleoGuideRoute = location.pathname.includes('/pleo-guide')

    return (
        <Navigate
            to={isPleoGuideRoute ? `${location.pathname}${location.search}` : 'pleo-guide'}
            replace
        />
    )
}
